export const isTokenExpired = (): boolean => {
  const token = localStorage.getItem("refreshToken");
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiry = payload.exp * 1000;
    return Date.now() > expiry;
  } catch (error) {
    return true;
  }
};

export const isAccessTokenExpired = (): boolean => {
  const token = localStorage.getItem("accessToken");
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiry = payload.exp * 1000;
    return Date.now() > expiry;
  } catch (error) {
    return true;
  }
};
